import { ANNOTATION_COLORS, DEFAULT_ANNOTATION_COLOR, type AnnotationColor } from "@lancer-vtt/domain";
import { storageGet, storageSet } from "../../../lib/browserStorage";

/**
 * The Pen tool's per-viewer preferences (`BoardToolRail.tsx`): its mode and its stroke colour, per
 * browser and remembered across reloads, like the VIEW toggles (`viewPrefs.ts`). A missing,
 * unreadable or unknown stored value reads as the default.
 */

/** Freehand is the drag-to-sketch stroke; Polygon places a vertex per click (the old Line tool). */
export type PenMode = "freehand" | "polyline";

export const PEN_PREF_KEYS = { mode: "lvtt.penMode", color: "lvtt.penColor" } as const;

export function readPenMode(): PenMode {
  const stored = storageGet(PEN_PREF_KEYS.mode);
  return stored.ok && stored.value === "polyline" ? "polyline" : "freehand";
}

export function writePenMode(mode: PenMode): void {
  storageSet(PEN_PREF_KEYS.mode, mode);
}

export function readPenColor(): AnnotationColor {
  const stored = storageGet(PEN_PREF_KEYS.color);
  const hit = stored.ok ? ANNOTATION_COLORS.find((c) => c === stored.value) : undefined;
  return hit ?? DEFAULT_ANNOTATION_COLOR;
}

export function writePenColor(color: AnnotationColor): void {
  storageSet(PEN_PREF_KEYS.color, color);
}
